import axios from 'axios'

// In dev, Vite proxy strips /api -> backend on :8000. In prod, set VITE_API_BASE.
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE || '/api',
  headers: { Accept: 'application/json' },
})

const TOKEN_KEY = 'lpk_cms_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}
export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  else localStorage.removeItem(TOKEN_KEY)
}

/**
 * Convert a backend storage URL to one the admin SPA can load.
 *
 * - Dev (Vite proxy): absolute URL like http://localhost:8000/storage/... →
 *   relative /storage/... so Vite proxy forwards it.
 * - Prod (VITE_API_BASE set): keep absolute URL as-is (backend domain is correct).
 */
export function storageUrl(url) {
  if (!url) return ''
  const apiBase = import.meta.env.VITE_API_BASE
  if (!apiBase) {
    // Dev mode — strip origin, keep /storage/... path
    try {
      const u = new URL(url)
      return u.pathname + u.search
    } catch {
      return url
    }
  }
  return url
}

api.interceptors.request.use((config) => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      setToken(null)
      // Only redirect if we're not already on the login page
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  },
)
